<template>
    <template v-if="loading">
        <ScaleLoader class="custom-loader" height="5rem" />
        <Skeleton height="10rem" class="mb-2"></Skeleton>
    </template>
    <div v-else class="gap-2">
        <!-- =====> Removed debriefApplianceJson chart from DebriefReportCharts-->
        <LearningByCallSign :jsonData="chartData.learning_by_appliances" />
        <OutcomeTypeByCallSign :jsonData="chartData.outcome_type_by_appliances" />
        <OutcomeTypeByPrimaryTheme :jsonData="chartData.outcome_type_by_primary_themes" />
        <OutcomeTypeBySecondaryTheme :jsonData="chartData.outcome_type_by_secondary_themes" />

        <div class="grid">
            <div class="col-6">
                <OutcomeType :jsonData="chartData.outcome_type" />
            </div>
            <div class="col-6">
                <LearningIdentified :jsonData="chartData.learning" />
            </div>
        </div>
        <IncidentTypes type="L1" :jsonData="chartData.incidentsL1" />
        <IncidentTypes type="L2" :jsonData="chartData.incidentsL2" />
        <IncidentTypes type="L3" :jsonData="chartData.incidentsL3" />
    </div>
</template>

<script setup>
import LearningByCallSign from './LearningByCallSign.vue';
import OutcomeTypeByCallSign from './OutcomeTypeByCallSign.vue';
import OutcomeTypeByPrimaryTheme from './OutcomeTypeByPrimaryTheme.vue';
import OutcomeTypeBySecondaryTheme from './OutcomeTypeBySecondaryTheme.vue';
import OutcomeType from './OutcomeType.vue';
import LearningIdentified from './LearningIdentified.vue';
import IncidentTypes from './IncidentTypes.vue';

import { onMounted, onUnmounted, ref, watch } from 'vue';
import { reportStore } from '@/store/global-stores';
import { showToast } from '@/utilities/toast-handler';

const props = defineProps({
    criteriaSet: {
        type: Boolean,
    },
});

const loading = ref(false);
const chartData = ref({
    learning_by_appliances: null,
    outcome_type_by_appliances: null,
    outcome_type_by_primary_themes: null,
    outcome_type_by_secondary_themes: null,
    outcome_type: null,
    learning: null,
    incidentsL1: null,
    incidentsL2: null,
    incidentsL3: null,
});

watch(
    () => props.criteriaSet,
    () => loadDebriefReportCharts()
);

onMounted(() => {
    loadDebriefReportCharts();
});

// After unmounting, clean the debrief criterias
onUnmounted(() => {
    reportStore.initDebriefCriteria();
});

const loadDebriefReportCharts = async () => {
    try {
        loading.value = true;
        // Setting to graphs to load graph data
        chartData.value = await reportStore.getDynamicDebriefReportData('template_graphs');
    } catch (error) {
        showToast({}, error?.data?.message ?? 'Failed to dynamic debrief report data');
    } finally {
        loading.value = false;
    }
};
</script>
